export const ZOOM_DEFAULT = 11;
export const ZOOM_DEFAULT_SANS_MARKER = 4;
export const ZOOM_DEFAULT_EMPLACEMENT = 17;
export const COULEUR_PUCE_DEFAULT = '#f44e3b';
export const COULEUR_PUCE_RED = '#f44e3b';

export const CENTER_DEFAULT = {
  lat: 48.8566969,
  lng: 2.3514616,
};

export const STYLE_MAPS_POI_HIDDEN = [
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];
